import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { Typography, Link, Container, Divider } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  spacer: {
    marginBottom: theme.spacing(2),
    backgroundColor: '#ddd',
  },
}))

const Footer = () => {
  const classes = useStyles()
  const year = new Date().getFullYear()

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Divider className={classes.spacer} />
      <Typography variant="body1">
        {year} &copy;{' '}
        <Link component="a" href="https://www.yapay.com.br" target="_blank">
          Yapay Pagamentos
        </Link>
      </Typography>{' '}
    </Container>
  )
}

Footer.propTypes = {
  className: PropTypes.string,
}

export default Footer
